import type { DayObject } from 'types/graphql'

export const PipelinesActions = {
  SELECT_PIPELINE: 'SELECT_PIPELINE',
  SET_DATA: 'SET_DATA',
}

export type PipelineAction =
  | {
      type: typeof PipelinesActions.SELECT_PIPELINE
      payload: {
        pipelineId: string
      }
    }
  | {
      type: typeof PipelinesActions.SET_DATA
      payload: {
        opportunities: DayObject[]
        pipelines: DayObject[]
        stages: DayObject[]
      }
    }

export type PipelinesState = {
  selectedPipelineId?: string
  opportunities: DayObject[]
  pipelines: DayObject[]
  stages: DayObject[]
  pipelineTitles: {
    title: string
    id: string
    type: string
  }[]
}

export const pipelinesReducer = (state, action: PipelineAction) => {
  if (action.type === PipelinesActions.SELECT_PIPELINE) {
    return {
      ...state,
      selectedPipelineId: action.payload.pipelineId,
    }
  } else if (action.type === PipelinesActions.SET_DATA) {
    return {
      ...state,
      pipelineTitles: (action.payload.pipelines || []).map(
        (pipelineDayObject) => ({
          id: pipelineDayObject.objectId,
          title: pipelineDayObject.properties.standard.title.value,
          type: pipelineDayObject.properties.standard.type.value,
        })
      ),
      opportunities: action.payload.opportunities,
      stages: action.payload.stages,
      pipelines: action.payload.pipelines,
    }
  }
}
